import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop';

import AboutUs from './pages/AboutUs';
import Career from './pages/Career';
import Home from './pages/Home';
import Sitemap from './pages/Sitemap';
import Schema from './pages/Schema';
import Product from './pages/Product';
// Gallery hidden until images are updated
// import Gallerys from './pages/Gallerys';
import Error from './pages/Error';

import Elements from './elements/elements/Elements';
import Contact from './elements/contact/Contact';
import Products from './elements/product/Products';
import ProductChildren from './elements/product/ProductChildren';
import ProductNodes from './pages/ProductNodes';

import portfolioThreeColumn from './elements/portfolio/PortfolioThreeColumn';
import PortfolioFullWidth from './elements/portfolio/PortfolioFullWidth';
import PortfolioGrid from './elements/portfolio/PortfolioGrid';
import PortfolioBoxLayout from './elements/portfolio/PortfolioBoxLayout';




// Import Css Here 
import './assets/scss/style.scss';


const App = () => {
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={Home}/>
                    {/* <Route path={`${process.env.PUBLIC_URL + "/home"}`} exact component={Home}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/business-consulting-2"}`} exact component={BusinessConsulting2}/>
                    <Route path={`${process.env.PUBLIC_URL + "/corporate"}`} exact component={Corporate}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/business"}`} exact component={Business}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/digital-agency"}`} exact component={DigitalAgency}/>
                    <Route path={`${process.env.PUBLIC_URL + "/finance"}`} exact component={Finance}/>
                    <Route path={`${process.env.PUBLIC_URL + "/company"}`} exact component={Company}/>
                    <Route path={`${process.env.PUBLIC_URL + "/marketing"}`} exact component={Marketing}/>
                    <Route path={`${process.env.PUBLIC_URL + "/travel-agency"}`} exact component={TravelAgency}/>
                    <Route path={`${process.env.PUBLIC_URL + "/consulting"}`} exact component={Consulting}/>
                    <Route path={`${process.env.PUBLIC_URL + "/seo-agency"}`} exact component={SeoAgency}/>
                    <Route path={`${process.env.PUBLIC_URL + "/personal-portfolio"}`} exact component={PersonalPortfolio}/>
                    <Route path={`${process.env.PUBLIC_URL + "/event-conference"}`} exact component={EventConference}/>
                    <Route path={`${process.env.PUBLIC_URL + "/creative-portfolio"}`} exact component={CreativePortfolio}/>
                    <Route path={`${process.env.PUBLIC_URL + "/freelancer"}`} exact component={Freelancer}/>
                    <Route path={`${process.env.PUBLIC_URL + "/international-consulting"}`} exact component={InternationalConsulting}/>
                    <Route path={`${process.env.PUBLIC_URL + "/startup"}`} exact component={Startup}/>
                    <Route path={`${process.env.PUBLIC_URL + "/web-agency"}`} exact component={WebAgency}/> */}

                    {/* Blog routes disabled — no blog section on this site */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} exact component={BlogGridView}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/blog-list-view"}`} exact component={BlogListView}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/blog-grid-sidebar"}`} exact component={BlogGridSidebar}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/blog"}`} exact component={BlogListSidebar}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/blog-details/:slug"}`} exact component={BlogDetails}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`} exact component={CategoryList}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/archive/:slug"}`} exact component={Author}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} exact component={TagList}/> */}

                    <Route path={`${process.env.PUBLIC_URL + "/elements"}`} exact component={Elements}/>
                    {/* <Route path={`${process.env.PUBLIC_URL + "/button"}`} exact component={Button}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/service"}`} exact component={Service}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/counter"}`} exact component={CounterUp}/>
                    <Route path={`${process.env.PUBLIC_URL + "/progressbar"}`} exact component={Progressbar}/>
                    <Route path={`${process.env.PUBLIC_URL + "/social-share"}`} exact component={Social}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/team"}`} exact component={Team}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/testimonial"}`} exact component={Testimonial}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/timeline"}`} exact component={Timeline}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/accordion"}`} exact component={RnAccordion}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/tab"}`} exact component={Tab}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/pricing"}`} exact component={Pricing}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/split"}`} exact component={Split}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/call-to-action"}`} exact component={CalltoAction}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/video-popup"}`} exact component={Video}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/gallery"}`} exact component={Gallery}/> */}
                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} exact component={Contact}/>
                    {/* <Route path={`${process.env.PUBLIC_URL + "/brand"}`} exact component={Brand}/>
                    <Route path={`${process.env.PUBLIC_URL + "/advance-tab"}`} exact component={AdvanceTab}/>
                    <Route path={`${process.env.PUBLIC_URL + "/advance-pricing"}`} exact component={AdvancePricing}/> */}
                    <Route path={`${process.env.PUBLIC_URL + "/about-us"}`} exact component={AboutUs}/>
                    <Route path={`${process.env.PUBLIC_URL + "/career"}`} exact component={Career}/>
                    {/* Gallery hidden until images are updated */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/gallerys"}`} exact component={Gallerys}/> */}

                    {/* <Route path={`${process.env.PUBLIC_URL + "/error"}`} exact component={Error}/> */}
                    
                    <Route path={`${process.env.PUBLIC_URL + "/product"}`} exact component={Product}/>
                    <Route path={`${process.env.PUBLIC_URL + "/products"}`} exact component={portfolioThreeColumn}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-full-width"}`} exact component={PortfolioFullWidth}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-grid-layout"}`} exact component={PortfolioGrid}/>
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-box-layout"}`} exact component={PortfolioBoxLayout}/>
                    {/* <Route path={`${process.env.PUBLIC_URL + "/portfolio-details/:id"}`} exact component={PortfolioDetails}/> */}
                    {/* <Route path={`${process.env.PUBLIC_URL + "/clients"}`} exact component={Clients}/> */}

                    {/* Product nodes routes MUST come before product-details to avoid route conflicts */}
                    {/* More specific routes (with nodePath) must come first */}
                    {/* Support both slug and numeric ID for backward compatibility */}
                    <Route path={`${process.env.PUBLIC_URL + "/product-nodes/:productSlug/:nodePath*"}`} component={ProductNodes}/>
                    <Route path={`${process.env.PUBLIC_URL + "/product-nodes/:productSlug"}`} exact component={ProductNodes}/>
                    
                    <Route path={`${process.env.PUBLIC_URL + "/product-children/:id"}`} exact component={ProductChildren}/>
                    
                    {/* Product details routes come after product-nodes */}
                    <Route path={`${process.env.PUBLIC_URL + "/product-details/:id"}`} exact component={Products}/>
                    <Route path={`${process.env.PUBLIC_URL + "/product-details"}`} exact component={Products}/>

                    {/* Sitemap route - serves sitemap.xml */}
                    <Route path={`${process.env.PUBLIC_URL + "/sitemap.xml"}`} exact component={Sitemap}/>

                    {/* Schema route - displays JSON-LD schemas */}
                    <Route path={`${process.env.PUBLIC_URL + "/schema"}`} exact component={Schema}/>

                    
          {/* ✅✅✅ FINAL 404 ROUTE (MUST BE LAST) */}
          <Route component={Error} />

                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App
